<div class="npgo">
  @if (isItemSelected() === false) {
    <div class="column">
      <label class="control"><span>Select from the following {{facilitytype}}:</span>
          <div class="wrap"><input type="text" class="input" placeholder="" [(ngModel)]="searchText"></div>
      </label>
    </div>

    <ul class="nth-nav">
      @for (item of childItems | normalize: searchText : 'label' | paginate: config; track $index) {
        <li #filterlink (click)="onMenuExtensionClicked(item, $event)" (mouseover)="onMouseOver(item)" (mouseout)="onMouseLeave(item)" data-toggle="modal" data-target="#myModal">
            {{ item.label }}
        </li>
      }
    </ul>

    <div>
      <pagination-controls #pagination [id]="config.id"
                          [maxSize]="maxSize"
                          [directionLinks]="directionLinks"
                          [autoHide]="autoHide"
                          [responsive]="responsive"
                          [previousLabel]="labels.previousLabel"
                          [nextLabel]="labels.nextLabel"
                          [screenReaderPaginationLabel]="labels.screenReaderPaginationLabel"
                          [screenReaderPageLabel]="labels.screenReaderPageLabel"
                          [screenReaderCurrentLabel]="labels.screenReaderCurrentLabel"
                          (pageChange)="onPageChange($event)"
                          (pageBoundsCorrection)="onPageBoundsCorrection($event)"
                          class="npgo-pagination">
      </pagination-controls>
    </div>
  }
</div>
